import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const VoterCommunicationsPage = lazy(() => import('src/pages/voter-communications'));
const PolicyAnalystPage = lazy(() => import('src/pages/voter-communications/policy-analyst'));
const CommunicationsToolAdminReportPage = lazy(() =>
  import('src/pages/voter-communications/admin-report')
);
// ----------------------------------------------------------------------

export const voterCommunicationsRoutes = [
  {
    path: 'communications',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <VoterCommunicationsPage />, path: 'general', index: true },
      { element: <PolicyAnalystPage />, path: 'policy-analyst' },
      { element: <CommunicationsToolAdminReportPage />, path: 'admin-report' },
    ],
  },
];
